import React from "react";
import { Field, FieldAttributes } from "formik";

import { StyledTextField } from "../StyledTextField";

const CustomFormikField: React.FC<FieldAttributes<any>> = props => (
  <Field name={props.name}>{() => <StyledTextField {...props} />}</Field>
);
export default CustomFormikField;
